<template lang="pug">
div.Case-list-content
  div.title 案例列表
  div.list-region
    ul.case-area
      li.list(@click='gonovice(v)',v-for='v in list' v-if="list.length !== 0" :title='v.experimentName')
        div.chart
          img.case-plan(:src='v.imagePath')
        div.list-tag
          p.label {{v.experimentName}}
        div.type-nav
          p.label-2(v-for='(x,idx) in v.caseTypes',v-if='idx<=2') {{x}}
        div.list-tag-2
          span.left {{v.endTime}}
          span.right.unstarted(v-if="!v.start") • 未开始
          span.right.finished(v-else-if='v.finish') • 已结束
          span.right.finished(v-else-if='v.complete && !v.finish') • 已完成
          span.right(v-else-if='!v.complete && !v.finish') • 未完成
      li.listnone( v-if="list.length === 0")
        span 暂无数据
</template>
<script>
export default {
  data() {
    return {
      list: [],
      willDoIndex: "",
      type: ["政策制定", "政策执行", "政策评估", "政策终结"]
    };
  },
  methods: {
    gonovice(v) {
      if (!v.start) {
        this.$Message.warning("未到开始时间，暂时无法进入");
        return false;
      }
      sessionStorage.removeItem("stageId");
      window.location.href = `/policy_stu/?id=${v.caseExperimentId}&experimentId=${v.experimentId}`;
      // return;
      // const data = {
      //   caseStep: "FORMULATE",
      //   pyId: v.caseExperimentId
      // };
      // if (!v.start) {
      //   this.$Message.warning("未到开始时间，暂时无法进入");
      //   return false;
      // }
      // if (v.beforeDistribution) {
      //   sessionStorage.beforeDistribution = this.type.indexOf(v.beforeDistribution);
      // } else {
      //   sessionStorage.beforeDistribution = -1;
      // }
      // // 通过点击将要执行的分配传进本地存储里
      // if (v.distribution === "政策制定") {
      //   this.willDoIndex = 1;
      // } else if (v.distribution === "政策执行") {
      //   this.willDoIndex = 2;
      // } else if (v.distribution === "政策评估") {
      //   this.willDoIndex = 3;
      // } else if (v.distribution === "政策终结") {
      //   this.willDoIndex = 4;
      // }
      // sessionStorage.setItem("willDoIndex", this.willDoIndex);
      // this.$http.getCasehallByPyIdAndCaseStep(data).then(res => {
      //   // console.log(res);
      //   const data1 = {
      //     index: "FORMULATE",
      //     tsId: res.data.data.id,
      //     stageShow: res.data.data.stageShow
      //   };
      //   this.$store.commit("postStuCaseInformation", data1);
      //   const data3 = {
      //     caseExperimentId: v.caseExperimentId,
      //     experimentId: v.experimentId
      //   };
      //   sessionStorage.setItem("doIndex", -1);
      //   sessionStorage.setItem("initialState", 1);
      //   this.$store.commit("postStuCaseId", data3);
      //   sessionStorage.setItem("schedule", v.schedule);
      //   // 判断是否结束状态
      //   if (v.finish) {
      //     this.$router.push({ path: "/doCase", query: { state: true } });
      //     return;
      //   }
      //   this.$router.push({ path: "/doCase", query: { state: false } });
      // });
    },
    // 调用接口
    query() {
      const data = {
        classId: sessionStorage.getItem("classId"),
        userId: this.$role.code
      };
      this.$http.querydistributiontrain(data).then(res => {
        // window.sessionStorage.setItem("caseTypes", JSON.stringify(res.data.data.caseTypes));
        // console.log(this);
        // console.log(res);
        if (res.data.success) {
          // console.log("res1", res.data.data.list);
          this.list = res.data.data.list;
          // console.log(this.list);
          this.list.forEach(res1 => {
            const res2 = res1;
            res2.caseTypes = JSON.parse(res1.caseTypes);
          });
        }
      });
    }
    // notcomplete()
  },
  created() {
    this.query();
  }
};
</script>
<style lang="stylus" scoped>
.Case-list-content
  width 1128px
  margin 0 auto
  .title
    text-align left
    font-size 24px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    margin-top 68px
  .list-region
    margin-top 48px
    .case-area
      display grid
      grid-template-columns 210px 210px 210px 210px 210px
      grid-column-gap 16px
      grid-row-gap 18px
      text-align left
      .list
        width 210px
        height 253px
        background #FFFFFF
        border-radius 4px
        cursor pointer
        .chart
          width 100%
          height 118px
          // background url('../../assets/Student/home/medal.png')
          margin 0 auto
          display block
          .case-plan
            width 100%
            height 100%
        .list-tag
          .label
            font-size 14px
            font-family MicrosoftYaHeiUI
            color rgba(42, 46, 54, 1)
            margin 8px 12px
            min-height 42px
            text-align left
            // display -webkit-box
            // -webkit-box-orient vertical
            // -webkit-line-clamp 2
            // overflow hidden
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
        .type-nav
          min-height 40px
          padding 0 8px
          .label-2
            display inline-block
            width 60px
            height 22px
            text-align center
            background rgba(60, 118, 208, 0.1)
            border-radius 2px
            margin-left 4px
            margin-bottom 4px
            font-size 12px
            font-family MicrosoftYaHeiUI
            color #3885E1
        .list-tag-2
          width 186px
          height 36px
          line-height 36px
          margin 0 12px
          border-top 1px solid #eee
          .left
            float left
            font-size 12px
            color rgba(42, 46, 54, 0.75)
          .right
            float right
            font-size 12px
            color rgba(128, 128, 128, 1)
          .finished
            color rgba(76, 169, 144, 1)
          .unstarted
            color rgba(0, 0, 0, 1)
      .listnone
        font-size 24px
</style>
